<template>
    <a-modal
        title="同步到巨量组织"
        centered
        :width="640"
        :mask-closable="false"
        :visible="showForm"
        :confirmLoading="loading"
        @cancel="close"
    >
        <a-alert
            message="仅支持升级版工作台组织同步素材"
            type="info"
            show-icon
            style="margin-bottom: 16px"
        />

        <a-spin :spinning="orgLoading">
            <div v-if="organizations.length === 0 && !orgLoading" style="text-align: center; padding: 20px;">
                <a-empty description="暂无可同步的组织配置，请先在巨量组织管理中添加" />
            </div>

            <div v-else>
                <div style="margin-bottom: 12px;">
                    <a-checkbox
                        :checked="isAllChecked"
                        :indeterminate="isIndeterminate"
                        @change="handleCheckAll"
                    >
                        全选
                    </a-checkbox>
                    <span style="margin-left: 16px; color: #999;">
                        已选择 {{ checkedIds.length }} / {{ organizations.length }} 个组织
                    </span>
                </div>

                <a-checkbox-group v-model="checkedIds" style="width: 100%;">
                    <a-row :gutter="[8, 8]">
                        <a-col :span="12" v-for="org in organizations" :key="org.id">
                            <a-checkbox :value="org.id" style="width: 100%;">
                                <span>{{ org.organize_name }}</span>
                                <span style="color: #999; margin-left: 8px; font-size: 12px;">(ID: {{ org.organize_id }})</span>
                            </a-checkbox>
                        </a-col>
                    </a-row>
                </a-checkbox-group>
            </div>
        </a-spin>

        <template slot="footer">
            <a-button @click="close" :disabled="loading">取消</a-button>
            <a-button
                type="primary"
                @click="submit"
                :loading="loading"
                :disabled="loading || checkedIds.length === 0"
            >
                确定同步
            </a-button>
        </template>
    </a-modal>
</template>

<style lang="less" scoped>
@import 'SyncToOrganization';
</style>

<script>
import SyncToOrganization from './SyncToOrganization'
export default SyncToOrganization
</script>
